import {login, logout, getUserRuleList} from '@/api/login';
import {getToken, setToken, removeToken} from '@/utils/auth';
import { getFileToken } from '@/api/account';

const user = {
    state: {
        token: getToken(),
        name: '',
        avatar: '',
        userInfo: {},
        roles: [],
        fileToken:'',
        oneLogin:1,
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_NAME: (state, name) => {
            state.name = name;
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar;
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles;
        },
        SET_USER_INFO: (state, userInfo) => {
            state.userInfo = userInfo;
        },
        SET_FILE_TOKEN: (state, fileToken) => {
            state.fileToken = fileToken;
        },
        SET_ONE_LOGIN: (state, flag) => {
            state.oneLogin = flag;
        }
    },

    actions: {
        setOneLogin({commit}, params){
            return new Promise(resolve => {
                console.log(params);
                commit('SET_ONE_LOGIN', params);
                resolve(params);
            });
        },
        getOneLogin(){
            return state.oneLogin;
        },
        // 登录
        Login({commit}, params) {
            const account = params.account.trim();
            const pwd = params.pwd;
            return new Promise((resolve, reject) => {
                var param = {
                  account:account,
                  pwd:pwd,
                  imgCode: params.imgCode
                };
                login(param).then(response => {

                    // reject(error);
                    const token = response.token;
                    const user= response.userInfo;
                    const userInfo = {
                        userName:user.nickName || user.realName,
                        picUrl:user.image,
                        userId:response.id,
                        orgId:response.organizationId,
                        phone:response.cellPhone,
                    };

                    // console.log(userInfo);

                    if (userInfo) {
                        setToken(token);

                        commit('SET_TOKEN', token);
                        commit('SET_USER_INFO', userInfo);
                        commit('SET_NAME', userInfo.userName);
                        commit('SET_AVATAR', userInfo.picUrl);
                        resolve(response.isChangePassword);
                    } else {
                        reject('error');
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },

        // 获取用户信息
        getUserRuleList({commit, state}) {
            return new Promise((resolve, reject) => {
                try {
                    getUserRuleList({token:getToken()}).then(response => {
                        const getMenuModules = response.getMenuModules;
                        var userName='';
                        if(response.userName){
                            userName=response.userName;
                        }else{
                            userName=response.organization;
                        }
                        const userInfo = {
                            userName:userName,
                            userMainnot:response.isZfp,
                            picUrl:response.userHeadUrl,
                            userId:response.userId,
                            phone:response.phone,
                            orgId:response.organizationId,
                        };

                        var superType = 0;
                        for(var i = 0; i < getMenuModules.length;i++){
                             if(getMenuModules[i].url == 'prassType'){
                                  userInfo.userTp = 0;
                                  superType++;
                             }else if(getMenuModules[i].url == 'companyType'){
                                  userInfo.userTp = 1;
                                  superType++;
                             }else if(getMenuModules[i].url == 'provinceType'){
                                  userInfo.userTp = 2;
                                  superType++;
                             }else if(getMenuModules[i].url == 'centralType'){
                                  userInfo.userTp = 3;
                                  superType++;
                             }
                        }

                        /*if(superType > 2){
                             userInfo.userTp = 'empty';
                        }else if(superType == 2){
                             userInfo.userTp = 4;
                        }*/

                        commit('SET_TOKEN', getToken());
                        commit('SET_ROLES', getMenuModules);
                        commit('SET_NAME', userInfo.userName);
                        commit('SET_USER_INFO', userInfo);
                        commit('SET_AVATAR', userInfo.picUrl);
                        resolve(response);

                    }).catch(
                        error => {
                            reject('error');
                        }
                    );
                } catch (e) {
                    reject('error');
                }
            });
        },

       fileTokenStore({commit,state}){
            return new Promise((resolve,reject) => {
                getFileToken().then(response => {
                    commit('SET_FILE_TOKEN',response.resultStatus.token);
                    resolve(response);
                }).catch(error => {
                    reject('error');
                })
            })
       },

        // 登出
        LogOut({commit, state}) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '');
                    commit('SET_ROLES', []);
                    removeToken();
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            });
        },

        // 前端 登出
        FedLogOut({commit}) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '');
                commit('SET_ROLES', []);
                removeToken();
                resolve();
            });
        }
    }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js